(function init() {
    var sentinel    = document.getElementById('lazy-sentinel');
    if (!sentinel) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        }
        return;
    }

    var pageId      = parseInt(sentinel.getAttribute('data-page-id'), 10);
    if (!pageId) return;

    var batchSize   = 12;
    var loaded      = parseInt(sentinel.getAttribute('data-loaded'), 10) || 0;
    var loading     = false;
    var hasMore     = true;
    var container   = document.getElementById('lazy-container');
    var viewMoreBtn = document.getElementById('view-more-btn');
    var spinner     = document.getElementById('lazy-spinner');
    var endMsg      = document.getElementById('lazy-end');

    if (!viewMoreBtn) return;

    (function createBackToTop() {
        if (document.getElementById('btn-back-to-top')) return;

        var btn = document.createElement('button');
        btn.className = 'btn-back-to-top';
        btn.id = 'btn-back-to-top';
        btn.setAttribute('aria-label', 'Back to top');

        var svgStr = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="17 11 12 6 7 11"></polyline>' +
            '<polyline points="17 18 12 13 7 18"></polyline>' +
            '</svg>';

        btn.innerHTML = svgStr + '<span>Back to top</span>';
        document.body.appendChild(btn);

        function updateVisibility() {
            if (window.scrollY > 200) {
                btn.classList.add('is-visible');
            } else {
                btn.classList.remove('is-visible');
            }
        }

        window.addEventListener('scroll', updateVisibility, { passive: true });

        btn.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    })();

    function makeResizedUrl(base, w, h) {
        if (!base) return '';
        return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w + '&height=' + h;
    }

    function buildLazyImageBlock(imageUrl) {
        // Match server markup: aspect 3:2 and responsive srcset (120/360/540)
        var ratio = '0.6666666666666666666666666667';
        var sizesAttr = '366px';
        var w1 = 120, w2 = 360, w3 = 540;
        var h1 = Math.round(w1 * 2 / 3), h2 = Math.round(w2 * 2 / 3), h3 = Math.round(w3 * 2 / 3);
        var u1 = makeResizedUrl(imageUrl, w1, h1);
        var u2 = makeResizedUrl(imageUrl, w2, h2);
        var u3 = makeResizedUrl(imageUrl, w3, h3);

        var dataSrc = u1;
        var dataSrcSet = u1 + ' ' + w1 + 'w,' + u2 + ' ' + w2 + 'w,' + u3 + ' ' + w3 + 'w';
        var srcSet = dataSrcSet;

        return '<div class="lazywrap " aspect="3:2">' +
            '<img class="lazyautosizes lazyloaded" data-src="' + dataSrc + '" data-srcset="' + dataSrcSet + '" data-ratio="' + ratio + '" sizes="' + sizesAttr + '" alt="" srcset="' + srcSet + '" src="' + dataSrc + '">' +
            '</div>';
    }

    function buildCard(item) {
        var img = '';
        if (item.hasImage && item.imageUrl) {
            var sdg = '';
            if (item.unSDGs && item.unSDGs.length) {
                sdg = '<div class="sdg-label"><span class="sdg">' +
                    item.unSDGs.map(function (s) {
                        var name = (s && (s.Name || s.name)) || s;
                        return '<a href="#" class="sdg-link"><img src="/images/unSDGs/' + name + '.png" alt="' + name + '" class="sdg-icon" /></a>';
                    }).join('') +
                    '</span></div>';
            }
            img = '<div class="card-image-wrap">' + buildLazyImageBlock(item.imageUrl) + sdg + '</div>';
        }
        return '<div class="item col-md-4"><article class="card">' + img +
            '<div class="card-body">' +
            '<h5 class="card-headline"><a href="' + (item.link || '#') + '">' + (item.title || '') + '</a></h5>' +
            '<small class="card-date">' + (item.shortDate || '') + '</small>' +
            '<p class="card-text">' + (item.text || '') + '</p>' +
            '</div></article></div>';
    }

    function showEnd() {
        hasMore = false;
        viewMoreBtn.classList.add('d-none');
        if (endMsg) endMsg.classList.remove('d-none');
    }

    function loadMore() {
        if (loading || !hasMore) return;
        loading = true;
        viewMoreBtn.classList.add('d-none');
        if (spinner) spinner.classList.add('show');

        fetch('/webapi/articles/load?pageId=' + pageId + '&skip=' + loaded + '&take=' + batchSize)
            .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.json();
            })
            .then(function (data) {
                if (data.items && data.items.length) {
                    var section = document.createElement('div');
                    section.className = 'container section-three-cards lazy-batch';
                    var html = '<div class="inner"><div class="row">';
                    data.items.forEach(function (item) { html += buildCard(item); });
                    html += '</div></div>';
                    section.innerHTML = html;
                    container.appendChild(section);
                    loaded += data.items.length;
                    requestAnimationFrame(function () { section.classList.add('visible'); });
                }
                loading = false;
                if (spinner) spinner.classList.remove('show');
                if (!data.hasMore) {
                    showEnd();
                } else {
                    viewMoreBtn.classList.remove('d-none');
                }
            })
            .catch(function (err) {
                console.error('Load more error:', err);
                loading = false;
                if (spinner) spinner.classList.remove('show');
                showEnd();
            });
    }

    viewMoreBtn.addEventListener('click', loadMore);
})();